import styled from '@emotion/styled'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { ButtonRow, Caption, StyledButton, Title } from './sharedStyles'
import { useModal } from 'components/Modal'
import Redirect from 'components/Redirect'
import useTemplateId from 'hooks/useTemplateId'
import { getGTMToken, getGTMTokenFromHash, getGoogleRedirectUrl, setGTMToken } from 'lib/gtm'

const ConnectionPanel = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	height: 100%;
`

const StyledImage = styled(Image)`
	border-radius: ${({ theme }) => theme.borderRadiuses.md};
	width: 100%;
	height: auto;
`

const StyledLink = styled(Link)`
	text-decoration: none;
`

const SignInStep = () => {
	const { hideModal } = useModal()
	const router = useRouter()
	const currentPath = router.asPath

	return (
		<ConnectionPanel>
			<Title>Install OpenWidget using Google Tag Manager</Title>
			<StyledImage src="/images/gtmAuth.png" alt="" draggable={false} width={400} height={230} />
			<Caption>
				Install OpenWidget via Google Tag Manager by signing into your Google account. After successful authorization,
				you will be redirected back to the OpenWidget to finish the process.
			</Caption>
			<ButtonRow>
				<StyledButton kind="secondary" onClick={hideModal}>
					Cancel
				</StyledButton>
				<StyledLink href={getGoogleRedirectUrl(currentPath)}>
					<StyledButton kind="primary">Sign in with Google</StyledButton>
				</StyledLink>
			</ButtonRow>
		</ConnectionPanel>
	)
}

function withGTMToken(Component: typeof SignInStep) {
	return function WithGTMToken() {
		const gtmToken = getGTMToken()
		const router = useRouter()
		const currentPath = router.asPath
		const { setUrlQueryTemplateId, withTemplateId } = useTemplateId()

		if (currentPath.includes('access_token') && currentPath.includes('scope')) {
			const gtmToken = getGTMTokenFromHash(currentPath)
			const urlParams = new URLSearchParams(currentPath.split('#')[1])
			const templateId = urlParams.get('state')

			if (gtmToken) {
				setGTMToken(gtmToken)

				if (templateId) {
					setUrlQueryTemplateId(templateId)
				}

				return <Redirect shallow to={`gtm/setup${templateId ? `?tid=${templateId}` : ''}`} />
			}
		}

		if (gtmToken) {
			return <Redirect shallow to={withTemplateId(`gtm/setup`)} />
		}

		return <Component />
	}
}

export default withGTMToken(SignInStep)
